import { createSelector } from "reselect";

import getUserAccount from "./get_user_account";

const getUserRole = createSelector([
  getUserAccount
], (account) => account?.role || null);

export default getUserRole;
